import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'


import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';


class EditUnit extends Component {

    constructor(){
        super();
        this.updateUnit = this.updateUnit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            userId:"",
            user :{},
            errorMsg : "",
            unitToBeUpdate : {}
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        });

        var unit = ref.child("Units").child(this.props.match.params.uid)
            unit.on("value", function(snap){
                this.setState({
                    unitToBeUpdate : snap.val()
                })
            }.bind(this))   
    }

    componentWillUnmount(){
      this.listener()
    }

    updateUnit(e){
         e.preventDefault();

        const updatedUnit=this.state.unitToBeUpdate;
        ref.child("Units").child(this.props.match.params.uid).update(updatedUnit).then(()=>{
        alert("Unit updated successfully")
        });
    }
    handleChange(e){
        let updateUnit = this.state.unitToBeUpdate;
        let update ={
            ...updateUnit,
            [e.target.name]:e.target.value
        } 
        this.setState({unitToBeUpdate:update})
    }

    render() {
      
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Category" />
                            <div className="block">
                                <form className="form-horizontal form-bordered" ref={(input) => {this.unitUpdateForm=input}}  onSubmit={(e)=>this.updateUnit(e)}>
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="category-name">Unit</label>
                                        <div className="col-md-4">
                                            <input className="form-control" value ={this.state.unitToBeUpdate.unit} name="unit" type="text" onChange={this.handleChange} />
                                        </div>
                                    </div>
                                                                       
                                    <div className="form-group form-actions">
                                        <div className="col-md-9 col-md-offset-3">
                                            <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-floppy-o"></i> Update Unit</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                                
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default EditUnit;



// WEBPACK FOOTER //
// ./src/components/EditUnit.js